import React, { useEffect, useState } from 'react';
import { Storage, Translate, translate } from 'react-jhipster';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import Collapse from '@mui/material/Collapse';
import Box from '@mui/material/Box';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Tooltip from '@mui/material/Tooltip';
import Switch from '@mui/material/Switch';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { updateEntity as updateBank } from 'app/entities/bank/bank.reducer';
import { AUTHORITIES } from 'app/config/constants';

export function CustomerLoginSetting() {
  const dispatch = useAppDispatch();
  const account = useAppSelector(state => state.authentication.account);
  const bankEntity = useAppSelector(state => state.bank.entity);

  const userRoleAccessList = useAppSelector(state => state.userManagement.userRoleAccessList);
  const isUserAuthorizedToEdit = userRoleAccessList.length === 0 || userRoleAccessList.some(role => role.bankId === bankEntity?.id);

  const [collapse, setCollapse] = useState(false);
  const [enableCustomerLogin, setEnableCustomerLogin] = useState(true);
  const [enableCustomerLoginApi, setEnableCustomerLoginApi] = useState(true);

  const handleCollapseToggle = () => {
    setCollapse(prev => !prev);
  };

  const handleSubmit = () => {
    const updatedBank = {
      ...bankEntity,
      enableCustomerLogin,
      enableCustomerLoginApi,
    };
    dispatch(updateBank(updatedBank));
  };

  useEffect(() => {
    if (bankEntity?.id !== undefined) {
      setEnableCustomerLogin(bankEntity.enableCustomerLogin !== false);
      setEnableCustomerLoginApi(bankEntity.enableCustomerLoginApi !== false);
    }
  }, [bankEntity]);

  const isDisabled =
    (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
      !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)) ||
    !isUserAuthorizedToEdit;

  const isRtl = Storage.session.get('locale') === 'ar-ly';

  const renderToggleRow = (
    label: string,
    helpText: string,
    value: boolean,
    onChange: () => void,
    switchName: string,
    tooltipEnabled: string,
    tooltipDisabled: string,
  ) => (
    <TableRow>
      <TableCell style={{ borderBottom: 'none' }}>
        <Grid container sx={{ alignItems: 'center' }}>
          <Grid item sm={10} md={10}>
            <Typography variant="body1" component={'div'} style={{ fontWeight: 700 }} align={isRtl ? 'right' : 'left'}>
              {label}
            </Typography>
            <Typography variant="body2" component={'div'} sx={{ mt: 0.5, color: 'text.secondary' }} align={isRtl ? 'right' : 'left'}>
              {helpText}
            </Typography>
          </Grid>
          <Grid item sm={2} md={2} sx={{ display: 'inline-flex', justifyContent: 'center' }}>
            <Tooltip title={value ? tooltipEnabled : tooltipDisabled}>
              <Switch checked={value} onChange={onChange} name={switchName} disabled={isDisabled} data-cy={switchName} />
            </Tooltip>
          </Grid>
        </Grid>
      </TableCell>
    </TableRow>
  );

  return (
    <div className="collapse-section">
      <Grid container className="align-items-center">
        <Grid item xs={10} sm={11} md={11.5}>
          <Typography variant="h5" component="div" data-cy="customerLoginSettingHeading">
            {translate('comexApp.bank.details.customerLoginSetting.title')}
          </Typography>
        </Grid>
        <Grid item xs={2} sm={1} md={0.5}>
          <IconButton aria-label="collapse" onClick={handleCollapseToggle}>
            {collapse ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
          </IconButton>
        </Grid>
      </Grid>
      <Collapse in={collapse}>
        <TableContainer className="my-3" sx={{ maxHeight: 400 }}>
          <Table>
            <TableBody>
              {renderToggleRow(
                translate('comexApp.bank.details.customerLoginSetting.enableCustomerLogin'),
                translate('comexApp.bank.details.customerLoginSetting.enableCustomerLoginHelp'),
                enableCustomerLogin,
                () => setEnableCustomerLogin(prev => !prev),
                'enableCustomerLogin',
                translate('comexApp.bank.details.customerLoginSetting.tooltip.enabled'),
                translate('comexApp.bank.details.customerLoginSetting.tooltip.disabled'),
              )}
              {renderToggleRow(
                translate('comexApp.bank.details.customerLoginSetting.enableCustomerLoginApi'),
                translate('comexApp.bank.details.customerLoginSetting.enableCustomerLoginApiHelp'),
                enableCustomerLoginApi,
                () => setEnableCustomerLoginApi(prev => !prev),
                'enableCustomerLoginApi',
                translate('comexApp.bank.details.customerLoginSetting.tooltip.apiEnabled'),
                translate('comexApp.bank.details.customerLoginSetting.tooltip.apiDisabled'),
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button type="submit" color="primary" onClick={handleSubmit} value={0} disabled={isDisabled}>
            <FontAwesomeIcon icon="plus" /> <Translate contentKey="comexApp.bank.details.update" />
          </Button>
        </Box>
      </Collapse>
    </div>
  );
}
